/**
 * Utility functions for cookie management
 */

/**
 * Gets a cookie value by name
 *
 * @param name Cookie name
 * @returns The cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

/**
 * Creates a cookie with the specified name and value
 *
 * @param name Cookie name
 * @param value Cookie value
 * @param daysToExpire Number of days until the cookie expires
 */
export function createCookie(
  name: string,
  value: string,
  daysToExpire: number = 365
): void {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + daysToExpire);

  document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Removes a cookie by setting its expiration date to the past
 *
 * @param name Cookie name to remove
 */
export function removeCookie(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
}
